<template>
      <div class="logo" :class="{'custom-logo': !default_logo}">
        <span v-if="default_logo" class="pp-icon pp-icon-logo"></span>
        <span v-if="default_logo" class="pp-icon-chief"></span>
        <img :src="custom_logo" v-if="!default_logo">
      </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: "Logo",
        props:['orange'],
        data: function (){
          return {

          };
        },
        computed: {
          ...mapGetters('app', {
            custom_logo: 'getLogo',
          }),
          default_logo: function (){
            return (this.custom_logo === null);
          }
        }
    }
</script>

<style scoped lang="scss">
  .custom-logo{
    img{
      max-width: 140px;
      max-height: 70px;
    }
  }
  @media (min-width: 1600px) {
    .custom-logo{
      img{
        max-width: 170px;
      }
    }
  }

</style>
